import { Localization } from "@viamap/viamap2-common";
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { ADModalBody, AdvancedDragModal } from "src/componentsUtils/AdvancedDragModal";

const RegexPatternDublicatedTranslations = /^(da|en) (.*) translation is duplicated$/;
export function ConsoleDisplayer() {
   const [logs, setLogs] = useState<string[]>([]);

   useEffect(() => {
      global.injectWarn?.();
      setTimeout(() => {
         global.stopInjectWarn?.();
         setLogs((global.warnList || []).filter(l => l.match(RegexPatternDublicatedTranslations)));
      }, 1000)
   }, [])

   if (logs.length === 0) {
      return null;
   }

   return (
      createPortal(
         <AdvancedDragModal title={Localization.getText("Translations duplicates")}
            onClose={() => setLogs([])}
            PosDefault={{ top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}
         >
            <ADModalBody>
               {
                  logs.map((l, idx) => {
                     return <div key={idx} style={{ color: "black" }} >{formatter(l)}</div>
                  })
               }
            </ADModalBody>
         </AdvancedDragModal>
         , document.body)
   )
}


function formatter(log: string,) {
   let x = log.match(RegexPatternDublicatedTranslations);

   if (!x || x.length < 3)
      return log;

   return <>
      <span style={{ color: "grey", fontSize: "0.8em", marginRight: "1ex" }}>
         {x[1]}
      </span>
      <span style={{ color: "red", fontWeight: "bold", marginRight: "1ex" }}>
         {x[2]}
      </span>
      <span>
         {Localization.getText("translation is duplicated")}
      </span>
   </>
}